import { AfterViewInit, Component, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'lepi-modal-container',
  template: `
    <section
      #modal
      class="w-screen h-dvh md:rounded-[20px] md:w-auto md:h-auto bg-white">
      <section class="rounded-t-[20px] overflow-hidden">
        <ng-content select="[header]" />
      </section>
      <section class="h-full md:min-w-120 md:max-h-240 md:h-auto">
        <ng-content />
      </section>
      <section
        class="md:static fixed bottom-0 w-full bg-white rounded-b-[20px] overflow-hidden">
        <ng-content select="[footer]" />
      </section>
    </section>
  `,
  imports: [],
})
export class ModalContainer implements AfterViewInit {
  modalRef = viewChild<ElementRef<HTMLElement>>('modal');

  ngAfterViewInit() {
    this.modalRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      }
    );
  }
}
